import OlMap from 'ol/Map';
import OlView from 'ol/View';
import OlVectorLayer from 'ol/layer/Vector';
import OlVectorSource from 'ol/source/Vector';
import OlGeoJSON from 'ol/format/GeoJSON';
import OlStyle from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import { defaults } from 'ol/control';
import { fromLonLat } from 'ol/proj';
import { lineSliceAlong } from '@turf/line-slice-along';
import { environment } from 'src/environments/environment';
import { TileLayerObj } from '../../GISMap/ol-exports';
import { dbS } from 'src/app/services/_offline/StorageDexie';

function previewMap(row: any, geo: any, map: any = undefined) {
  let tileLayers = TileLayerObj;
  let karte = JSON.parse(localStorage.getItem('karte')) ?? { p: 'google', m: 'googleMaps' };
  let kartenFarben = JSON.parse(localStorage.getItem('karteFarbe')) ?? { bC: 'rgba(0,0,0,0.6)', hEC: '#FEAC88' };
  let layers = [tileLayers[karte.p][karte.m]];

  let geolayer;
  let selectlayer;
  let curFeatlayer;
  if (geo) {
    selectlayer = new OlVectorLayer({
      source: new OlVectorSource({
        format: new OlGeoJSON(),
        loader: (extent, resolution, projection) => {
          let featurewrap: any = {
            type: 'Feature',
            geometry: geo,
          };
          let feature;
          if (geo.type == 'Point') {
            feature = selectlayer.getSource().getFormat().readFeature(featurewrap, { featureProjection: 'EPSG:3857' });
          } else {
            let von = row.von || row.Startmeter?.value || 0;
            let bis = row.bis || row.Endmeter?.value || 0;
            if (bis - von < 1) {
              bis = parseFloat(von + 1);
            }
            von = parseFloat(((von - row.baseVon) / 1000).toString());
            bis = parseFloat(((bis - row.baseVon) / 1000).toString());
            let slicedFeature = lineSliceAlong(featurewrap, von, bis);
            feature = selectlayer
              .getSource()
              .getFormat()
              .readFeature(slicedFeature, { featureProjection: 'EPSG:3857' });
          }
          selectlayer.getSource().addFeature(feature);
        },
      }),
      style: feature => {
        let color = 'red';
        let fk =
          row.fehlerklasse ? row.fehlerklasse
          : row.Fehlerklasse ? row.Fehlerklasse
          : undefined;
        switch (fk) {
          case 1:
            color = 'red';
            break;
          case 2:
            color = 'yellow';
            break;
          case 3:
            color = 'green';
            break;
          case 4:
            color = 'blue';
            break;
          default:
            color = 'red';
            break;
        }
        return new OlStyle({
          stroke: new OlStroke({
            color: color,
            width: 4,
          }),
          zIndex: 0,
        });
      },
    });
    geolayer = new OlVectorLayer({
      source: new OlVectorSource({
        format: new OlGeoJSON(),
        loader: (extent, resolution, projection) => {
          dbS.getGIS(localStorage.getItem('DB') + localStorage.getItem('karteFileID')).then(x => {
            if (x?.features?.length > 0) {
              //Lade per GIS-IndexedDB
              let src = geolayer.getSource();
              setTimeout(() => {
                let features = src.getFormat().readFeatures(x, {
                  featureProjection: 'EPSG:3857',
                });
                src.addFeatures(features);
              });
            } else {
              let xhr = new XMLHttpRequest();
              let token = localStorage.getItem('jwt');
              xhr.open('GET', environment.apiUrl + '/karte/topojson', true);
              xhr.setRequestHeader('Authorization', 'Bearer ' + token);
              let onError = () => {
                geolayer.getSource().removeLoadedExtent(extent);
              };
              xhr.onerror = onError;
              xhr.onload = () => {
                if (xhr.status == 200) {
                  let src = geolayer.getSource();
                  setTimeout(() => {
                    let features = src.getFormat().readFeatures(xhr.responseText, {
                      featureProjection: 'EPSG:3857',
                    });
                    src.addFeatures(features);
                  });
                } else {
                  onError();
                }
              };
              xhr.send();
            }
          });
        },
      }),
      style: feature => {
        return new OlStyle({
          stroke: new OlStroke({
            color: kartenFarben.bC,
            width: 4,
          }),
          zIndex: 0,
        });
      },
    });
    curFeatlayer = new OlVectorLayer({
      source: new OlVectorSource({
        format: new OlGeoJSON(),
        loader: (extent, resolution, projection) => {
          let featurewrap: any = {
            type: 'Feature',
            geometry: geo,
          };
          let fullFeature = curFeatlayer
            .getSource()
            .getFormat()
            .readFeature(featurewrap, { featureProjection: 'EPSG:3857' });
          curFeatlayer.getSource().addFeature(fullFeature);
        },
      }),
      style: feature => {
        return new OlStyle({
          stroke: new OlStroke({
            color: kartenFarben.hEC,
            width: 4,
            lineDash: [6, 6],
          }),
          zIndex: 0,
        });
      },
    });
    layers.push(geolayer, curFeatlayer, selectlayer);
  }

  if (map) {
    map.setLayers(layers);
  } else {
    map = new OlMap({
      target: 'previewMap',
      layers: layers,
      view: new OlView({
        center: fromLonLat([6.747443, 49.981018]),
        maxZoom: 23,
        zoom: 15,
      }),
      controls: defaults({ attribution: false, rotate: false, zoom: false }),
    });
  }
  if (geo) {
    geolayer.getSource().once('change', () => {
      map.getView().fit(selectlayer.getSource().getExtent(), { duration: 100, maxZoom: 21 });
    });
  }
  return map;
}

export { previewMap };
